export const getColumnWidthsForXlsx = data => {
  return data[0].map((_, colIndex) => ({
    wch:
      Math.max(
        ...data.map(row =>
          row[colIndex] ? row[colIndex].toString().length : 0
        )
      ) + 2 // Adding padding for better spacing
  }));
};
